import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Loader2 } from 'lucide-react';
import {} from 'react';
import { cn } from '@/lib/utils';
export function Spinner({ className, ...props }) {
    return (_jsx("span", { role: "status", "aria-label": "Chargement", className: cn('inline-flex items-center justify-center text-electric-300', className), ...props, children: _jsx(Loader2, { className: "h-5 w-5 animate-spin" }) }));
}
export function Skeleton({ className, ...props }) {
    return (_jsx("div", { role: "status", "aria-label": "Chargement", className: cn('relative overflow-hidden rounded-xl bg-ink-800/70', className), ...props, children: _jsx("div", { className: "absolute inset-0 bg-shimmer" }) }));
}
/**
 * Barre de progression (XP, BP, completion). value ∈ [0, 100].
 */
export function ProgressBar({ value, className, variant = 'electric', }) {
    const safe = Math.max(0, Math.min(100, value));
    const fill = {
        electric: 'bg-gradient-electric',
        flame: 'bg-gradient-flame',
        royal: 'bg-gradient-royal',
        gold: 'bg-gradient-podium',
    };
    return (_jsxs("div", { role: "progressbar", "aria-valuenow": safe, "aria-valuemin": 0, "aria-valuemax": 100, className: cn('relative h-2.5 w-full overflow-hidden rounded-full bg-ink-800', className), children: [_jsx("div", { className: cn('h-full rounded-full transition-[width] duration-500 ease-out', fill[variant]), style: { width: `${safe}%` } }), _jsx("div", { className: "pointer-events-none absolute inset-0 bg-shimmer opacity-60" })] }));
}
